import React from 'react'
import { Navigate, useLocation } from 'react-router-dom';
import { isTokenExpired } from './util';

const ProtectedRoute = ({ component: Component, children, ...restProps }) => {
    const location = useLocation();
    const loginData = JSON.parse(sessionStorage.getItem('loginData'));

    const userAccessCheck = () => {
        // const isUserAuthenticated = loginData && loginData?.access_token && !isTokenExpired(loginData?.access_token)
        const isUserAuthenticated = loginData
            &&
            (
                (loginData?.access_token && !isTokenExpired(loginData?.access_token)) || (loginData?.refresh_token && !isTokenExpired(loginData?.refresh_token))
            );
        const userLogin = ['/dashboard', '/configuration', '/history'];
        const userPagesCheck = userLogin.includes(location.pathname) ? true : false;

        return isUserAuthenticated ? true : userPagesCheck;
    }

    return userAccessCheck() ? children : <Navigate to='/not-authorize' />;
};

export default ProtectedRoute;